import { render, staticRenderFns } from "./Claim.vue?vue&type=template&id=4a2b78f4&scoped=true"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b78f4",
  null
  
)

export default component.exports